import '@/lib/sentryConfig'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import Router from '@/config/Router'
import Providers from './providers'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>
)
